export enum NoteType {
  Text = 0,
  Voice = 1,
  Video = 2
}
